// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-voucher-wrapper {
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  background-color: var(--color-button-text);
  cursor: auto;
}
.checkout-voucher-wrapper .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 500 !important;
  line-height: var(--font-paragraph-line) !important;
  cursor: auto;
}
.checkout-voucher-wrapper .vert-text {
  font-size: var(--font-paragraph);
  font-weight: 400 !important;
  line-height: var(--font-paragraph-line) !important;
  cursor: auto;
}
.checkout-voucher-wrapper .checkout-voucher-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  margin-bottom: var(--spacing-small);
}
.checkout-voucher-wrapper .checkout-voucher-title .vert-icon {
  cursor: auto;
}
.checkout-voucher-wrapper .checkout-voucher-title .vert-icon svg {
  width: 18px;
  height: 18px;
  fill: var(--color-neutral-dark-darker);
}
.checkout-voucher-wrapper .checkout-voucher-title .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 24px !important;
  margin: 0;
  text-align: left;
  cursor: auto;
}
.checkout-voucher-wrapper .checkout-voucher-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
}
.checkout-voucher-wrapper .checkout-voucher-info {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
.checkout-voucher-wrapper .vert-input {
  width: 100%;
  max-width: 450px;
}
.checkout-voucher-wrapper .vert-input[disabled] {
  background-color: var(--bg-color-disabled-input) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text-input-disabled) !important;
}
.checkout-voucher-wrapper .vert-button {
  width: 100%;
  max-width: 300px;
}
@media screen and (max-width: 768px) {
  .checkout-voucher-wrapper {
    padding: var(--spacing-small);
    background-color: var(--color-button-text);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Checkout/CheckoutVoucherStyles.less"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,wDAAA;EACA,gDAAA;EACA,0CAAA;EACA,YAAA;AAAF;AALA;EAQI,gCAAA;EACA,2BAAA;EACA,kDAAA;EACA,YAAA;AAAJ;AAXA;EAcI,gCAAA;EACA,2BAAA;EACA,kDAAA;EACA,YAAA;AAAJ;AAjBA;EAqBI,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mCAAA;AADJ;AAvBA;EA2BM,YAAA;AADN;AA1BA;EA6BQ,WAAA;EACA,YAAA;EACA,sCAAA;AAAR;AA/BA;EAoCM,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAFN;AAvCA;EA8CI,aAAA;EACA,sBAAA;EACA,2BAAA;AAJJ;AA5CA;EAoDI,aAAA;EACA,sBAAA;EACA,yBAAA;AALJ;AAjDA;EA0DI,WAAA;EACA,gBAAA;AANJ;AAQI;EACE,2DAAA;EACA,4CAAA;EACA,kDAAA;AANN;AA1DA;EAoEI,WAAA;EACA,gBAAA;AAPJ;AAYA;EACE;IACE,6BAAA;IACA,0CAAA;EAVF;AACF","sourcesContent":["// DESKTOP\n.checkout-voucher-wrapper {\n  padding: var(--spacing-regular);\n  border-radius: var(--border-radius-secondary) !important;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n  background-color: var(--color-button-text);\n  cursor: auto;\n\n  .vert-paragraph {\n    font-size: var(--font-paragraph);\n    font-weight: 500 !important;\n    line-height: var(--font-paragraph-line) !important;\n    cursor: auto;\n  }\n  .vert-text {\n    font-size: var(--font-paragraph);\n    font-weight: 400 !important;\n    line-height: var(--font-paragraph-line) !important;\n    cursor: auto;\n  }\n\n  .checkout-voucher-title {\n    display: flex;\n    align-items: center;\n    gap: var(--spacing-extra-small);\n    margin-bottom: var(--spacing-small);\n\n    .vert-icon {\n      cursor: auto;\n      svg {\n        width: 18px;\n        height: 18px;\n        fill: var(--color-neutral-dark-darker);\n      }\n    }\n\n    .vert-title {\n      font-size: var(--font-medium);\n      font-weight: 600;\n      line-height: 24px !important;\n      margin: 0;\n      text-align: left;\n      cursor: auto;\n    }\n  }\n\n  .checkout-voucher-content {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-regular);\n  }\n\n  .checkout-voucher-info {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-small);\n  }\n\n  .vert-input {\n    width: 100%;\n    max-width: 450px;\n\n    &[disabled] {\n      background-color: var(--bg-color-disabled-input) !important;\n      border-color: var(--color-border) !important;\n      color: var(--color-text-input-disabled) !important;\n    }\n  }\n  .vert-button {\n    width: 100%;\n    max-width: 300px;\n  }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .checkout-voucher-wrapper {\n    padding: var(--spacing-small);\n    background-color: var(--color-button-text);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
